<template>
  <div class="col-md-12" style="margin-top: 3%">
    <v-layout row wrap> </v-layout>
    <v-container>
      <h4 class="earth-color">Proof Of Residency</h4>
      <v-layout row wrap>
        <table class="table table-striped table-bordered">
          <tbody>
            <tr v-for="(residency, key) in proofOfResidency" :key="key">
              <td>
                <v-text-field
                  readonly
                  label="Residency"
                  v-model="proofOfResidency[key].payment_person"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  readonly
                  label="Point Of Proof"
                  v-model="proofOfResidency[key].proof_point"
                ></v-text-field>
               
              </td>

              <td>
                <v-text-field
                  label="First Name"
                  v-model="proofOfResidency[key].first_name"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  label="Last Name"
                  v-model="proofOfResidency[key].last_name"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  label="Document Id"
                  v-model="proofOfResidency[key].document_id"
                ></v-text-field>
              </td>
            </tr>
          </tbody>
        </table>
        <v-flex lg3>
          <v-btn
            :depressed="true"
            color="info"
            dark
            class="white--text"
            small
            slot="activator"
            @click="booking_ref_proof = true"
          >
            Use Booking Reference
          </v-btn>
        </v-flex>

        <v-dialog v-model="booking_ref_proof" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">
                <h4 class="earth-color">BOOKING REF Number</h4>
              </span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      label="Booking ref"
                      required
                      v-model="proof_booking_id.booking_id"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <div class="row" v-if="proofOfResidencyBookingId.length > 0">
                <div class="col-md-12">
                  <h6 class="earth-color">
                    Booking {{ proof_booking_id.booking_id }} Proofs
                  </h6>
                  <table
                    cellpadding="1"
                    cellspacing="1"
                    class="table table-bordered"
                  >
                    <thead>
                      <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Residency</th>
                        <th>Point of proof</th>
                        <th>Document ID</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(proof_id, key) in proofOfResidencyBookingId"
                        :key="key"
                      >
                        <td>{{ proof_id.first_name }}</td>
                        <td>{{ proof_id.last_name }}</td>
                        <td>{{ proof_id.payment_person }}</td>
                        <td>{{ proof_id.proof_point }}</td>
                        <td>{{ proof_id.document_id }}</td>

                        <td>
                          <v-btn
                            :depressed="true"
                            color="error"
                            @click="removeProofBookingId(key)"
                            >x</v-btn
                          >
                          <span></span>
                        </td>
                      </tr>

                      <v-flex lg4 md4 sm12 xs12>
                        <v-btn color="primary" @click="confirmBookingProofs"
                          >Use All</v-btn
                        >
                      </v-flex>
                    </tbody>
                  </table>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                flat
                @click="booking_ref_proof = false"
                >Close</v-btn
              >
              <v-btn
                color="green darken-1"
                flat
                @click="getBookingProofs()"
                :loading="$loadingTrue"
                >Search</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  name: "residency-proof",
  data() {
    return {
      proof: {
        first_name: "",
        last_name: "",
        residency: "",
        document_id: "",
      },
      route: this.$route.name,
      booking_ref_proof: false,
      proof_booking_id: {
        booking_id: "",
      },
      preload_proof: false,
    };
  },

  created() {
    this.$store.dispatch("get_full_conservation_fees");
  },
  methods: {
    addProof() {
      let proofed_arr = this.conservationFeesProof;

      for (let i = 0; i < proofed_arr.length; i++) {
        let current_proof = proofed_arr[i];
        if (
          current_proof.first_name != "" &&
          current_proof.last_name != "" &&
          current_proof.document_id != "" &&
          current_proof.payment_person != "" &&
          current_proof.payment_public_id != ""
        ) {
          let new_proof = {
            new_first_name: current_proof.first_name,
            new_last_name: current_proof.last_name,
            new_residency: {
              payment_person: current_proof.payment_person,
              payment_public_id: current_proof.payment_public_id,
            },
            new_document_id: current_proof.document_id,
          };
          this.$store.commit("ADD_PROOF_RESIDENCY", new_proof);
        }
      }
    },

    getBookingProofs() {
      this.$store.dispatch("loading_true");
      // this.booking_ref_proof = false;
      this.preload_proof = true;
      let data = {
        booking_id: this.proof_booking_id.booking_id,
      };
      this.$store.dispatch("get_proof_of_residence", data);
    },
    confirmBookingProofs() {
      this.booking_ref_proof = false
      
    },
  },
};
</script>

<style scoped>
</style>
